// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Messages-module__icon___E8KfU{font-size:40px}`, "",{"version":3,"sources":["webpack://./src/modules/meritBadgeCounselors/mbcBulkEntry/components/Messages.module.scss"],"names":[],"mappings":"AAAA,+BACE,cAAA","sourcesContent":[".icon {\n  font-size: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `Messages-module__icon___E8KfU`
};
export default ___CSS_LOADER_EXPORT___;
